export const EXECUTIVE_SUMMARY_BTN_FILTERS = [
  { id: "dis_btn", name: "DIS Overview", navigateTo: "/executive_summary/dis" },
  { id: "dis_deep_dive_btn", name: "DIS Deep-Dive", navigateTo: "/purchase_funnel_report" },
  { id: "product_btn", name: "Product Performance", navigateTo: "/executive_summary/product_performance" },
  { id: "product_deep_dive_btn", name: "Product Performance - deep dive", navigateTo: "/executive_summary/product_performance_deep_dive" },
];
